import { RegistrationScreen } from '@/components/utils/RegistrationScreen';
import { PasswordField } from '@design-system/DataForm/PasswordField';
import * as P from '@/constants/paths';
import useResetPassword from '@/hooks/useResetPassword';
import CircularLoader from '@/components/utils/CircularLoader';

export const ResetPassword = () => {
  const { form, onSubmit, isVerifying, isSubmitting, isFormValid } =
    useResetPassword();

  // Show loading state while verifying token
  if (isVerifying) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <CircularLoader />
      </div>
    );
  }

  return (
    <RegistrationScreen
      form={form}
      title="Create new password"
      description="Please enter your new password below and confirm it."
      content={
        <div className="mt-8" data-testid="resetPassword-content">
          <PasswordField
            name="password"
            placeholder="Password"
            autoComplete="new-password"
            data-testid="resetPassword-passwordInput"
          />
          <PasswordField
            name="confirmPassword"
            placeholder="Confirm Password"
            className="mt-5"
            autoComplete="off"
            data-testid="resetPassword-confirmPasswordInput"
          />
        </div>
      }
      previousPath={P.PASSWORD_RECOVERY_PATH}
      primaryActionLabel="Reset Password"
      primaryActionIsSubmit
      primartActionDisabled={!isFormValid}
      isLoading={isSubmitting}
      formOnValid={onSubmit}
      data-testid="resetPassword-screen"
      hideBackButton
    />
  );
};
